import { useEffect } from 'react';

const SitemapXml = () => {
  useEffect(() => {
    // Fetch and display the sitemap.xml content
    fetch('/sitemap.xml')
      .then(response => response.text())
      .then(text => {
        // Set content type and display as XML
        document.body.innerHTML = `<pre style="font-family: monospace; white-space: pre-wrap;">${text}</pre>`;
      })
      .catch(() => {
        document.body.innerHTML = 'sitemap.xml not found';
      });
  }, []);

  return null;
};

export default SitemapXml;
